import React, { useEffect, useState } from 'react'
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { api } from '../../../../services/Main/Api'
import Masks from '../../../../components/Shared/Masks'
import moment from 'moment/moment'

const CustomerInvoiceDetailDialog = ({ open, customerInvoiceId, onClose }) => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!open || !customerInvoiceId) return
        setLoading(true)
        setData(null)
        api.get(`customer-invoice/rate/${customerInvoiceId}/`)
            .then(res => setData(res.data))
            .catch(err => console.error(err))
            .finally(() => setLoading(false))
    }, [open, customerInvoiceId])

    const renderRateRows = (items) => {
        if (!Array.isArray(items) || items.length === 0) return null
        return items.map(rate => (
            <TableRow key={rate.id}>
                <TableCell>TRA-{rate.id}</TableCell>
                <TableCell>{rate?.description}</TableCell>
                <TableCell>{moment(rate.reference_date).format('DD/MM/YYYY')}</TableCell>
                <TableCell>{Masks.money(rate.rate?.toString())}</TableCell>
                <TableCell>{rate.status_billing}</TableCell>
            </TableRow>
        ))
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            scroll="paper"
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" color="primary.main">
                    Detalhes da Tarifa
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {loading ? (
                    <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress />
                    </Box>
                ) : data ? (
                    <Box>
                        {/* Header */}
                        <Typography variant="h6" color="primary.main" sx={{ mb: 2 }}>
                            CLI-{data.id}
                        </Typography>

                        <Divider sx={{ mb: 2 }} />

                        {/* Tabela de tarifas */}
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Código</TableCell>
                                    <TableCell>Empresa</TableCell>
                                    <TableCell>Data</TableCell>
                                    <TableCell width={150}>Valor</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {renderRateRows(data?.rates)}
                                {renderRateRows(data?.invoices)}
                                {renderRateRows(data?.charges)}

                                <TableRow>
                                    <TableCell />
                                    <TableCell />
                                    <TableCell align="right">
                                        <Typography sx={{ fontWeight: 'bold' }} color={data?.total < 0 ? 'error.main' : undefined}>
                                            Total:
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '1.3rem' }} color={data?.total < 0 ? 'error.main' : undefined}>
                                            {Masks.money(data?.total?.toString())}
                                        </Typography>
                                    </TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableBody>
                        </Table>

                        {/* Dados do cliente */}
                        <Box sx={{ mt: 3 }}>
                            <Typography variant="subtitle1" color="primary.main" gutterBottom fontWeight="bold">
                                Dados do Cliente
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <Table size="small">
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Nome</TableCell>
                                        <TableCell>{data?.name}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>CPF/CNPJ</TableCell>
                                        <TableCell>{data?.cpf_cnpj}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Referente</TableCell>
                                        <TableCell>{data?.month}/{data?.year}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                                        <TableCell>{data?.status?.value}</TableCell>
                                    </TableRow>
                                    {data?.reason && (
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Razão</TableCell>
                                            <TableCell>{data?.reason}</TableCell>
                                        </TableRow>
                                    )}
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Total</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
                                            {Masks.money(data?.total?.toString())}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Box>
                ) : null}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default CustomerInvoiceDetailDialog
